import { Injectable, inject } from '@angular/core'
import { ToastButton, ToastController, ToastOptions } from '@ionic/angular'

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastController = inject(ToastController)

  private defaultToastOptions: ToastOptions = {
    position: 'top',
    positionAnchor: 'navbar',
    buttons: [],
    color: 'warning',
    duration: 5000,
  }

  async presentToast(
    toastOptions: ToastOptions,
    manualDismiss: boolean = false,
  ) {
    toastOptions = { ...this.defaultToastOptions, ...toastOptions }

    if (manualDismiss) {
      toastOptions.buttons = []
      const dismissBtn: ToastButton = {
        text: 'Dismiss',
        role: 'cancel',
      }
      toastOptions.buttons?.push(dismissBtn)
    }

    const toast = await this.toastController.create(toastOptions)

    await toast.present()
    return toast
  }

  /**
   * Show a success toast message
   * @param message The success message to display
   * @param duration Optional custom duration in ms
   */
  async showSuccessToast(message: string, duration: number = 3000) {
    return this.presentToast({
      message,
      color: 'success',
      duration,
    })
  }

  /**
   * Show an error toast message
   * @param message The error message to display
   * @param duration Optional custom duration in ms
   */
  async showErrorToast(message: string, duration: number = 5000) {
    return this.presentToast({
      message,
      color: 'danger',
      duration,
    })
  }
}
